export default "__VITE_ASSET__D9_L5T8Z__"